var _g, _path, _path2, _linearGradient, _path3, _linearGradient2, _path4, _linearGradient3, _path5, _linearGradient4, _path6, _g2, _linearGradient5, _path7, _path8, _path9, _path10, _path11, _g3, _path12, _linearGradient6, _path13, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFig3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 350,
    height: 295.6,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fc5b3f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.2 181.8c-6.2 11.7-17.4 20.8-20.5 33.6-1.4 5.5-1 11.3-1.7 17-2.5 19.9-17.3 36.3-35.1 45.7-.8.4-1.5.8-2.3 1.2-11.7 5.7-24.3 8.8-37.1 10.7-7.8 1.2-15.7 1.9-23.6 2.5-32.6 2.6-65.2 3.5-98 2.8-15.8-.3-31.9-1.1-46.8-6.3-.8-.3-1.5-.5-2.3-.8-12.1-4.6-22.8-12.3-32.3-21.2l-.4-.4c-14.1-13.2-25.9-29.2-33.4-47C-1.1 194-2.9 165.7 4.4 139c4.5-15.9 12.3-30.9 13.5-47.3.9-12.3-2-24.8-.1-37 4-24.3 26.5-42.1 50.3-48.1s48.9-2.6 73.2.8c11.9 1.7 25.8 6.3 37.5 2.6C193.2 5.6 205.4 0 221 0c6.3 0 12.8.7 18.7 3.2 7.1 3.1 12.7 8.7 18.4 13.9 16 14.3 34.2 25.9 50.6 39.9 16.4 13.9 31.2 30.9 37.2 51.6 3 10.1 3.7 20.7 4 31.2.5 14.3 0 29.3-6.7 42z",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4 95.6h166c7.1 0 12.9 5.7 12.9 12.9v110.8c0 7.1-5.7 12.9-12.9 12.9h-166c-7.1 0-12.9-5.7-12.9-12.9V108.5c-.1-7.2 5.8-12.9 12.9-12.9z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.2 105.3h168.4v114.3H93.2z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.4 158.6h5v45.9h-5zm8.7 7.5h5v38.4h-5zm8.6 6.8h5v31.5h-5zm8.7-6.8h5v38.4h-5zm8.5 15.4h5v23h-5zm8.8-15.4h5v38.4h-5zm8.5 11.5h5v26.9h-5zm8.7-5.2h5v32h-5zm-119.4 14h28.7v1.7h-28.7zm0 4.7h28.7v1.7h-28.7zm0 4.6h28.7v1.7h-28.7zm0 4.7h28.7v1.7h-28.7zm0 4.6h28.7v1.7h-28.7zm29.3-77.3c-10.3 0-18.7 8.3-18.8 18.6 0 10.3 8.3 18.7 18.6 18.8v-6.5h-.1c-6.8 0-12.3-5.5-12.3-12.3s5.5-12.3 12.3-12.3 12.3 5.5 12.3 12.3c0 .6-.1 1.2-.2 1.8h6.6c.1-.5.1-1 .1-1.6.2-10.4-8.1-18.8-18.5-18.8z",
    fill: "#fc5b3f"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    gradientUnits: "userSpaceOnUse",
    x1: 305.951,
    y1: -80.113,
    x2: 288.574,
    y2: 237.372
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#fff",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#fff",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M270.4 112.3h46.8c3.5 0 6.3 2.8 6.3 6.3v45.7c0 3.5-2.8 6.3-6.3 6.3h-46.8c-3.5 0-6.3-2.8-6.3-6.3v-45.7c0-3.5 2.8-6.3 6.3-6.3z",
    fill: "url(#A)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "B",
    gradientUnits: "userSpaceOnUse",
    x1: 233.889,
    y1: -246.705,
    x2: 216.504,
    y2: 70.781
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#fff",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.8 28h46.8c3.5 0 6.3 2.8 6.3 6.3V80c0 3.5-2.8 6.3-6.3 6.3h-46.8c-3.5 0-6.3-2.8-6.3-6.3V34.2c.1-3.4 2.9-6.2 6.3-6.2z",
    fill: "url(#B)"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "C",
    gradientUnits: "userSpaceOnUse",
    x1: 84.176,
    y1: -172.372,
    x2: 66.791,
    y2: 145.114
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#fff",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6 21.5h46.8c3.5 0 6.3 2.8 6.3 6.3v45.7c0 3.5-2.8 6.3-6.3 6.3H48.6c-3.5 0-6.3-2.8-6.3-6.3V27.7c-.1-3.4 2.8-6.2 6.3-6.2z",
    fill: "url(#C)"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "D",
    gradientUnits: "userSpaceOnUse",
    x1: 66.695,
    y1: -82.075,
    x2: 49.318,
    y2: 235.41
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#fff",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2 108.9H78c3.5 0 6.3 2.8 6.3 6.3V161c0 3.5-2.8 6.3-6.3 6.3H31.2c-3.5 0-6.3-2.8-6.3-6.3v-45.7c.1-3.6 2.9-6.4 6.3-6.4z",
    fill: "url(#D)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fc5b3f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.2 177.7l-.6-.1 11-42.5h20v.6h-19.5zM187.6 69.6h-9.1l-25 83.7-.6-.1 25-84.3h9.7zm-48.1 64.1l-22-68.9h-17.1v-.7H118l.1.3 22.1 69.1zm-25.3 26l-15.6-17.4H83.3v-.7h15.6l15.8 17.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.4 148.2c-.8 9.6-8.9 17.1-18.6 17.1h-.1v-6.5c6.1 0 11.2-4.6 12.2-10.6h6.5z"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "E",
    gradientUnits: "userSpaceOnUse",
    x1: 136.943,
    y1: 138.336,
    x2: 168.612,
    y2: 182.116
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#fff",
    stopOpacity: 0.39
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fff",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M159.4 148c-.8 9.6-8.9 17.1-18.6 17.1h-.1v-6.5c6.1 0 11.2-4.6 12.2-10.6h6.5z",
    fill: "url(#E)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6 167.4l8.7-18.2 20.1 11.7-13.8 28.5-10.8-6z",
    fill: "#fc5b3f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3 165.6l7.3-14.1 16.5 9.6-12.5 25.1-8.5-6.5z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7 210.5l5.7 35.8-5.7 35.7 3.2 2.5-5.3-.3.5-36.8-10-25.9 1.2 27-5.8 34.7 2.5 1.4-5.8-.3 2.5-36.1-4.6-21.6s-4-15.6 0-18.3 21.6 2.2 21.6 2.2z",
    fill: "#3e3e54"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6 156.9s14 1.6 17.5 4.1 7.1 6.6 7.1 9.8 1.4 19.3 1.4 19.3l5.8-13.4 3.2 1.9s-3.7 23.3-5.8 24-7.8-.8-7.8-.8l-.3 8.8s-19 1.9-21.6-2.1c-2.5-4.1-8.5-45.1.5-51.6z",
    fill: "#fc5b3f"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#eea886"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.7 152.6s-1.7 3.5-.8 6.5c0 0-5.2-.7-5.4-1.4-.2-.6.7-6.1.1-7.8s6.1 2.7 6.1 2.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1 138c2-.8 7.7-2.1 9.7 6.3 2.1 8.4-1.1 8.8-4.3 8.8-3.3 0-8.8-5.2-9.3-7s-2-5.5 3.9-8.1zm25.6 34.8c0-.3 0-.4.1-.7.2-.6.8-.9 1.2-1.5.2-.3.3-.8.3-1.1a1.93 1.93 0 01.3-1c.2-.3.5-.5.8-.5.5.1.8.6.8 1 .8 2.8.7 5.7-.3 8.5-.2.4-.4.8-.8.8-.2 0-.3-.1-.4-.2-.8-.4-2-.8-2.1-1.9s0-2.3.1-3.4z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M108.6 169.8l-4-3.7-.3.7 3.6 3.8c.1 0 .8-.2.7-.8z",
    fill: "#fc5b3f"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "F",
    gradientUnits: "userSpaceOnUse",
    x1: 107.183,
    y1: 185.551,
    x2: 68.576,
    y2: 219.113
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1 201.7s-2-.8-2.7-6.8l-1.5-12v27.8h4.6l-.4-9z",
    fill: "url(#F)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3 136.2c-.3-.9-1-1.7-1.9-2.1-.7-.4-1.4-.4-2.1-.1-.4-.6-1.1-.9-1.8-.9-.6-.1-1.2 0-1.7.3s-.8.9-.7 1.5c-.8-.1-1.7-.1-2.5 0-.3 0-.5.1-.8.3-.3.3-.5.5-.6.8-.4 1.1-.7 2.2-.7 3.4a3.88 3.88 0 00-1.5 2.7c-.1 1.1.4 2.1 1.2 2.9-.3 1.1-.2 2.3.4 3.3.7 1 1.9 1.4 3 1.2 0 .5.1 1.1.5 1.4a.9.9 0 00.5.1c.5 0 1-.1 1.4-.3-.1.4-.1.8 0 1.2s.4.7.8.7c.3-.1.5-.2.8-.4.6-.4 1-1 1.3-1.6.1-.6.2-1.2.2-1.9.2-.8.6-1.4.4-2.1s-.8-1-1.2-1.5-.8-1.3-.3-1.7 1.2-.1 1.6.4c.3.2.5.4.8.3s.2-.5.1-.8c-.3-.5-.4-1.1-.6-1.7s0-1.3.5-1.7c.8-.6 1.9-.3 2.6-.8.9-.8.6-2.2.3-2.9z",
    fill: "#3e3e54"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFig3);
export default __webpack_public_path__ + "static/media/fig3.7cbf7b50f350e179a8dd241239982bdb.svg";
export { ForwardRef as ReactComponent };